"use strict";
import R from "ramda";
import inside from "point-in-polygon";
import AnnotationComponents from "./components";
import DragPoint from "./drag_point";
import { BOUNDING_BOX_PADDING, DRAG_POINT_RADIUS } from "./constants";
import utils from "../../util/drawing_utils";
const { getRectPointsBetween } = utils;
const MIN_WIDTH = DRAG_POINT_RADIUS * 2;
const sanitise = (width) => {
  const w = width > MIN_WIDTH ? width : MIN_WIDTH;
  return w + 2 * BOUNDING_BOX_PADDING;
};
export const get2PointBoundingBox = (width) => (connectors) => {
  const [p1, p2] = connectors;
  const fullWidth = sanitise(width);
  const rectanglePoints = getRectPointsBetween(p1, p2, fullWidth);
  return R.map((p) => [p.x, p.y], rectanglePoints);
};
export function isPointIn(p, polygon) {
  const point = [p.x, p.y];
  return inside(point, polygon);
}
export const hoverFor = (mousePos) => (typeID, dragPoints) => {
  const Comp = AnnotationComponents[typeID];
  const hoveredDragPointIndex = R.findIndex(DragPoint.isPointIn(mousePos), dragPoints);
  const isIndex = R.is(Number, hoveredDragPointIndex) && hoveredDragPointIndex >= 0;
  return {
    hovered: isPointIn(mousePos, Comp.getBoundingBox(dragPoints)) || isIndex,
    dragPointIndex: isIndex ? hoveredDragPointIndex : false
  };
};
